
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3551_62724)"}},[_c('path',{attrs:{"d":"M12 23.719c6.472 0 11.719-5.247 11.719-11.719C23.719 5.528 18.472.281 12 .281 5.528.281.281 5.528.281 12c0 6.472 5.247 11.719 11.719 11.719z","fill":"#5C6BC0"}}),_c('path',{attrs:{"d":"M18.964 7.377c-2.077-1.49-4.013-1.553-4.383-1.56l-.236.223c2.652.742 3.934 1.9 3.934 1.9C16.003 6.842 13.86 6.456 12 6.432c-1.858.024-4.003.41-6.28 1.51 0 0 1.283-1.16 3.935-1.9l-.236-.225c-.37.008-2.305.07-4.383 1.56 0 0-2.32 3.894-2.32 8.675.078-.092 1.439 2.055 4.948 2.132 0 0 .59-.657 1.016-1.236-2.046-.58-2.817-1.738-2.817-1.738C7.989 16.524 9.976 17.03 12 16.965c2.024.065 4.01-.44 6.138-1.756 0 0-.772 1.159-2.818 1.738.425.58 1.015 1.236 1.015 1.236 3.51-.077 4.871-2.224 4.95-2.132 0-4.781-2.321-8.674-2.321-8.674zm-9.82 7.176c-.897 0-1.621-.742-1.621-1.653 0-.912.724-1.653 1.62-1.653v.007c.89 0 1.621.742 1.621 1.653 0 .904-.723 1.646-1.62 1.646zm5.712 0c-.897 0-1.62-.742-1.62-1.646 0-.911.731-1.653 1.62-1.653v-.007c.897 0 1.621.741 1.621 1.653 0 .911-.723 1.653-1.62 1.653z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3551_62724"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    